import { jsx as f, Fragment as ee, jsxs as z } from "react/jsx-runtime";
import * as s from "react";
import { useState as $, useCallback as A, useEffect as E, cloneElement as fe, isValidElement as he, useRef as k, forwardRef as ge } from "react";
import "react-dom";
function me(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var L = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var V;
function ve() {
  return V || (V = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (r = o(r, a.call(this, u)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var u in r)
          n.call(r, u) && r[u] && (i = o(i, this && this[u] || u));
        return i;
      }
      function o(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(L)), L.exports;
}
var _e = ve();
const be = /* @__PURE__ */ me(_e), ye = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, we = be.bind(ye), q = "purpur-icon", Se = "md", xe = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Ce = ({ content: e = "", title: n } = {}) => {
  const t = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = n ? `<title>${n}</title>` : "";
  return `<svg ${xe(t)}>${a}${e}</svg>`;
}, $e = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), re = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: t,
  className: a,
  size: o = Se,
  ...r
}) => {
  const i = Ce({
    content: $e(n.svg),
    title: t
  }), u = we(a, q, `${q}--${o}`);
  return /* @__PURE__ */ f(
    "span",
    {
      className: u,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...r
    }
  );
};
re.displayName = "Icon";
const Re = {
  name: "checkmark-bold",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.243 4.176a2 2 0 0 1 .324 2.81l-10.45 13.176a2.092 2.092 0 0 1-3.118.18l-5.413-5.413A2 2 0 1 1 5.414 12.1l3.9 3.9 9.118-11.5a2 2 0 0 1 2.81-.324Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark-bold"],
  category: "utility"
};
function H(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Pe(...e) {
  return (n) => {
    let t = !1;
    const a = e.map((o) => {
      const r = H(o, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let o = 0; o < a.length; o++) {
          const r = a[o];
          typeof r == "function" ? r() : H(e[o], null);
        }
      };
  };
}
var te = s.forwardRef((e, n) => {
  const { children: t, ...a } = e, o = s.Children.toArray(t), r = o.find(Ee);
  if (r) {
    const i = r.props.children, u = o.map((c) => c === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ f(X, { ...a, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, u) : null });
  }
  return /* @__PURE__ */ f(X, { ...a, ref: n, children: t });
});
te.displayName = "Slot";
var X = s.forwardRef((e, n) => {
  const { children: t, ...a } = e;
  if (s.isValidElement(t)) {
    const o = De(t), r = Ne(a, t.props);
    return t.type !== s.Fragment && (r.ref = n ? Pe(n, o) : o), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
X.displayName = "SlotClone";
var ke = ({ children: e }) => /* @__PURE__ */ f(ee, { children: e });
function Ee(e) {
  return s.isValidElement(e) && e.type === ke;
}
function Ne(e, n) {
  const t = { ...n };
  for (const a in n) {
    const o = e[a], r = n[a];
    /^on[A-Z]/.test(a) ? o && r ? t[a] = (...i) => {
      r(...i), o(...i);
    } : o && (t[a] = o) : a === "style" ? t[a] = { ...o, ...r } : a === "className" && (t[a] = [o, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function De(e) {
  var n, t;
  let a = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, o = a && "isReactWarning" in a && a.isReactWarning;
  return o ? e.ref : (a = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, o = a && "isReactWarning" in a && a.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var Oe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Me = Oe.reduce((e, n) => {
  const t = s.forwardRef((a, o) => {
    const { asChild: r, ...i } = a, u = r ? te : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(u, { ...i, ref: o });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), je = "Label", ne = s.forwardRef((e, n) => /* @__PURE__ */ f(
  Me.label,
  {
    ...e,
    ref: n,
    onMouseDown: (t) => {
      var a;
      t.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
ne.displayName = je;
var ze = ne;
function Ae(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var T = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var F;
function Xe() {
  return F || (F = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (r = o(r, a(u)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var u in r)
          n.call(r, u) && r[u] && (i = o(i, u));
        return i;
      }
      function o(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(T)), T.exports;
}
var Be = Xe();
const We = /* @__PURE__ */ Ae(Be), D = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, O = "purpur-label", Le = ({
  children: e,
  className: n,
  disabled: t,
  negative: a = !1,
  ...o
}) => {
  const r = We([
    n,
    D[O],
    {
      [D[`${O}--disabled`]]: t,
      [D[`${O}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ f(ze, { className: r, ...o, children: e });
};
function Ve(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var I = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var U;
function qe() {
  return U || (U = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (r = o(r, a(u)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var u in r)
          n.call(r, u) && r[u] && (i = o(i, u));
        return i;
      }
      function o(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(I)), I.exports;
}
var He = qe();
const Te = /* @__PURE__ */ Ve(He), R = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, Fe = {
  PARAGRAPH100: "paragraph-100"
}, P = "purpur-paragraph", oe = ({
  ["data-testid"]: e,
  children: n,
  className: t,
  disabled: a,
  enableHyphenation: o = !1,
  negative: r = !1,
  variant: i = Fe.PARAGRAPH100,
  ...u
}) => {
  const c = Te([
    t,
    R[P],
    R[`${P}--${i}`],
    {
      [R[`${P}--hyphens`]]: o,
      [R[`${P}--disabled`]]: a,
      [R[`${P}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ f("p", { ...u, className: c, "data-testid": e, children: n });
};
oe.displayName = "Paragraph";
function Ie(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), t === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function Z(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function ae(...e) {
  return (n) => {
    let t = !1;
    const a = e.map((o) => {
      const r = Z(o, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let o = 0; o < a.length; o++) {
          const r = a[o];
          typeof r == "function" ? r() : Z(e[o], null);
        }
      };
  };
}
function Ue(...e) {
  return s.useCallback(ae(...e), e);
}
function Ze(e, n = []) {
  let t = [];
  function a(r, i) {
    const u = s.createContext(i), c = t.length;
    t = [...t, i];
    const l = (d) => {
      var _;
      const { scope: p, children: g, ...h } = d, m = ((_ = p == null ? void 0 : p[e]) == null ? void 0 : _[c]) || u, b = s.useMemo(() => h, Object.values(h));
      return /* @__PURE__ */ f(m.Provider, { value: b, children: g });
    };
    l.displayName = r + "Provider";
    function v(d, p) {
      var m;
      const g = ((m = p == null ? void 0 : p[e]) == null ? void 0 : m[c]) || u, h = s.useContext(g);
      if (h) return h;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [l, v];
  }
  const o = () => {
    const r = t.map((i) => s.createContext(i));
    return function(u) {
      const c = (u == null ? void 0 : u[e]) || r;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...u, [e]: c } }),
        [u, c]
      );
    };
  };
  return o.scopeName = e, [a, Ge(o, ...n)];
}
function Ge(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const a = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(r) {
      const i = a.reduce((u, { useScope: c, scopeName: l }) => {
        const d = c(r)[`__scope${l}`];
        return { ...u, ...d };
      }, {});
      return s.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
function ie(e) {
  const n = s.useRef(e);
  return s.useEffect(() => {
    n.current = e;
  }), s.useMemo(() => (...t) => {
    var a;
    return (a = n.current) == null ? void 0 : a.call(n, ...t);
  }, []);
}
function Je({
  prop: e,
  defaultProp: n,
  onChange: t = () => {
  }
}) {
  const [a, o] = Ke({ defaultProp: n, onChange: t }), r = e !== void 0, i = r ? e : a, u = ie(t), c = s.useCallback(
    (l) => {
      if (r) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && u(d);
      } else
        o(l);
    },
    [r, e, o, u]
  );
  return [i, c];
}
function Ke({
  defaultProp: e,
  onChange: n
}) {
  const t = s.useState(e), [a] = t, o = s.useRef(a), r = ie(n);
  return s.useEffect(() => {
    o.current !== a && (r(a), o.current = a);
  }, [a, o, r]), t;
}
function Qe(e) {
  const n = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
var Ye = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function er(e) {
  const [n, t] = s.useState(void 0);
  return Ye(() => {
    if (e) {
      t({ width: e.offsetWidth, height: e.offsetHeight });
      const a = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const r = o[0];
        let i, u;
        if ("borderBoxSize" in r) {
          const c = r.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, u = l.blockSize;
        } else
          i = e.offsetWidth, u = e.offsetHeight;
        t({ width: i, height: u });
      });
      return a.observe(e, { box: "border-box" }), () => a.unobserve(e);
    } else
      t(void 0);
  }, [e]), n;
}
var ue = s.forwardRef((e, n) => {
  const { children: t, ...a } = e, o = s.Children.toArray(t), r = o.find(tr);
  if (r) {
    const i = r.props.children, u = o.map((c) => c === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ f(B, { ...a, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, u) : null });
  }
  return /* @__PURE__ */ f(B, { ...a, ref: n, children: t });
});
ue.displayName = "Slot";
var B = s.forwardRef((e, n) => {
  const { children: t, ...a } = e;
  if (s.isValidElement(t)) {
    const o = or(t), r = nr(a, t.props);
    return t.type !== s.Fragment && (r.ref = n ? ae(n, o) : o), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
B.displayName = "SlotClone";
var rr = ({ children: e }) => /* @__PURE__ */ f(ee, { children: e });
function tr(e) {
  return s.isValidElement(e) && e.type === rr;
}
function nr(e, n) {
  const t = { ...n };
  for (const a in n) {
    const o = e[a], r = n[a];
    /^on[A-Z]/.test(a) ? o && r ? t[a] = (...u) => {
      r(...u), o(...u);
    } : o && (t[a] = o) : a === "style" ? t[a] = { ...o, ...r } : a === "className" && (t[a] = [o, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function or(e) {
  var a, o;
  let n = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, t = n && "isReactWarning" in n && n.isReactWarning;
  return t ? e.ref : (n = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, t = n && "isReactWarning" in n && n.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var ar = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], se = ar.reduce((e, n) => {
  const t = s.forwardRef((a, o) => {
    const { asChild: r, ...i } = a, u = r ? ue : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ f(u, { ...i, ref: o });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), W = "Switch", [ir, xr] = Ze(W), [ur, sr] = ir(W), ce = s.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: t,
      name: a,
      checked: o,
      defaultChecked: r,
      required: i,
      disabled: u,
      value: c = "on",
      onCheckedChange: l,
      form: v,
      ...d
    } = e, [p, g] = s.useState(null), h = Ue(n, (y) => g(y)), m = s.useRef(!1), b = p ? v || !!p.closest("form") : !0, [_ = !1, C] = Je({
      prop: o,
      defaultProp: r,
      onChange: l
    });
    return /* @__PURE__ */ z(ur, { scope: t, checked: _, disabled: u, children: [
      /* @__PURE__ */ f(
        se.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": _,
          "aria-required": i,
          "data-state": de(_),
          "data-disabled": u ? "" : void 0,
          disabled: u,
          value: c,
          ...d,
          ref: h,
          onClick: Ie(e.onClick, (y) => {
            C((w) => !w), b && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ f(
        cr,
        {
          control: p,
          bubbles: !m.current,
          name: a,
          value: c,
          checked: _,
          required: i,
          disabled: u,
          form: v,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
ce.displayName = W;
var le = "SwitchThumb", pe = s.forwardRef(
  (e, n) => {
    const { __scopeSwitch: t, ...a } = e, o = sr(le, t);
    return /* @__PURE__ */ f(
      se.span,
      {
        "data-state": de(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...a,
        ref: n
      }
    );
  }
);
pe.displayName = le;
var cr = (e) => {
  const { control: n, checked: t, bubbles: a = !0, ...o } = e, r = s.useRef(null), i = Qe(t), u = er(n);
  return s.useEffect(() => {
    const c = r.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== t && d) {
      const p = new Event("click", { bubbles: a });
      d.call(c, t), c.dispatchEvent(p);
    }
  }, [i, t, a]), /* @__PURE__ */ f(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: t,
      ...o,
      tabIndex: -1,
      ref: r,
      style: {
        ...e.style,
        ...u,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function de(e) {
  return e ? "checked" : "unchecked";
}
var lr = ce, pr = pe;
function dr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var M = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var G;
function fr() {
  return G || (G = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var u = arguments[i];
          u && (r = o(r, a(u)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var u in r)
          n.call(r, u) && r[u] && (i = o(i, u));
        return i;
      }
      function o(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(M)), M.exports;
}
var hr = fr();
const j = /* @__PURE__ */ dr(hr), J = (e) => e && "touches" in e, gr = ({
  children: e,
  disabled: n,
  onStart: t,
  onDrag: a,
  onStop: o,
  bounds: r,
  position: i,
  style: u
}) => {
  const [c, l] = $(void 0), [v, d] = $(void 0), [p, g] = $(!1), h = (_) => {
    if (!n) {
      _.preventDefault();
      const C = J(_.nativeEvent) ? _.nativeEvent.touches[0].clientX : _.nativeEvent.clientX;
      d(C), t == null || t();
    }
  }, m = A(
    (_) => {
      if (typeof v != "number")
        return;
      const y = (J(_) ? _.touches[0].clientX : _.clientX) - v;
      if (!y)
        return;
      const w = i + y;
      !p && Math.abs(w) && g(!0);
      const N = w > r.right ? r.right : w < r.left ? r.left : w;
      l(N), a == null || a({ x: N });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [a, l, p, v]
  ), b = A(() => {
    d(void 0), l(void 0), g(!1), o == null || o();
  }, [o, d]);
  return E(() => (window.addEventListener("mousemove", m), window.addEventListener("touchmove", m), () => {
    window.removeEventListener("mousemove", m), window.removeEventListener("touchmove", m);
  }), [m]), E(() => (window.addEventListener("mouseup", b), window.addEventListener("touchend", b), () => {
    window.removeEventListener("mouseup", b), window.removeEventListener("touchend", b);
  }), [b]), he(e) ? fe(e, {
    onMouseDown: h,
    onTouchStart: h,
    style: { ...u, transform: `translateX(${p ? c : i}px)` }
  }) : null;
}, K = {
  width: void 0,
  height: void 0
};
function Q(e) {
  const { ref: n, box: t = "content-box", round: a } = e, [{ width: o, height: r }, i] = $(K), u = mr(), c = k({ ...K }), l = k(void 0);
  return l.current = e.onResize, E(() => {
    if (!n.current || typeof window > "u" || !("ResizeObserver" in window))
      return;
    const v = new ResizeObserver(([d]) => {
      const p = t === "border-box" ? "borderBoxSize" : t === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", g = Y(d, p, "inlineSize"), h = Y(d, p, "blockSize");
      if (c.current.width !== g || c.current.height !== h) {
        const b = {
          width: g && a ? Math.round(g) : g,
          height: h && a ? Math.round(h) : h
        };
        c.current.width = g, c.current.height = h, l.current ? l.current(b) : u() && i(b);
      }
    });
    return v.observe(n.current, { box: t }), () => {
      v.disconnect();
    };
  }, [t, n, u, a]), { width: o, height: r };
}
function Y(e, n, t) {
  return e[n] ? Array.isArray(e[n]) ? e[n][0][t] : (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Support Firefox's non-standard behavior
    e[n][t]
  ) : n === "contentBoxSize" ? e.contentRect[t === "inlineSize" ? "width" : "height"] : void 0;
}
function mr() {
  const e = k(!1);
  return E(() => (e.current = !0, () => {
    e.current = !1;
  }), []), A(() => e.current, []);
}
const vr = ({ checked: e, onChange: n }) => {
  const t = k(null), a = k(null), [o, r] = $(void 0), [i, u] = $(!1), [c, l] = $(0), { height: v = 0 } = Q({ ref: a, round: !0 }), { height: d = 0 } = Q({ ref: t, round: !0 }), p = (d || 0) - v, g = v + p, h = p / 2, m = g / 2, b = typeof o == "number" && (e ? o < m : o > m);
  return {
    trackRef: t,
    thumbRef: a,
    isDragging: i,
    bounds: { left: h, right: g },
    position: e ? g : h,
    onDrag: ({ x: w }) => {
      r(w), Math.abs((e ? g : h) - w) > 2 && u(!0);
    },
    onStop: () => {
      u(!1), i && l(Date.now()), b && (n == null || n(!e));
    },
    onChangeWithDrag: () => {
      Date.now() - c > 50 && (n == null || n(!e)), r(void 0);
    }
  };
}, S = {
  "purpur-toggle": "_purpur-toggle_1xng6_1",
  "purpur-toggle__track": "_purpur-toggle__track_1xng6_7",
  "purpur-toggle__checkmark-container": "_purpur-toggle__checkmark-container_1xng6_45",
  "purpur-toggle__thumb": "_purpur-toggle__thumb_1xng6_60",
  "purpur-toggle__thumb--dragging": "_purpur-toggle__thumb--dragging_1xng6_80",
  "purpur-toggle__checkmark": "_purpur-toggle__checkmark_1xng6_45",
  "purpur-toggle__label--right": "_purpur-toggle__label--right_1xng6_100",
  "purpur-toggle__label--left": "_purpur-toggle__label--left_1xng6_103",
  "purpur-toggle__container": "_purpur-toggle__container_1xng6_106"
}, x = "purpur-toggle", _r = ({
  ["data-testid"]: e,
  className: n,
  label: t,
  onChange: a,
  labelPosition: o = "right",
  checked: r,
  disableDrag: i,
  defaultChecked: u,
  ...c
}, l) => {
  const [v, d] = $(
    typeof r == "boolean" ? r : !!u
  ), p = !!(typeof r == "boolean" ? r : v), { thumbRef: g, trackRef: h, isDragging: m, onChangeWithDrag: b, ..._ } = vr({
    checked: p,
    onChange: (y) => {
      c.disabled || (a == null || a(y), d(y));
    }
  }), C = () => /* @__PURE__ */ f(
    Le,
    {
      htmlFor: c.id,
      "data-testid": e && `${e}-label`,
      disabled: c.disabled,
      className: j(
        S[`${x}__label`],
        S[`${x}__label--${o}`]
      ),
      children: /* @__PURE__ */ f(oe, { disabled: c.disabled, children: t })
    }
  );
  return /* @__PURE__ */ z("div", { className: j([n, S[`${x}__container`]]), children: [
    t && o === "left" && C(),
    /* @__PURE__ */ f(
      lr,
      {
        ...c,
        ref: l,
        id: c.id,
        "data-testid": e,
        className: S[x],
        onCheckedChange: b,
        checked: p,
        children: /* @__PURE__ */ z("span", { ref: h, className: S[`${x}__track`], children: [
          /* @__PURE__ */ f("span", { className: S[`${x}__checkmark-container`], children: /* @__PURE__ */ f(
            re,
            {
              className: S[`${x}__checkmark`],
              svg: Re,
              size: "xxs"
            }
          ) }),
          /* @__PURE__ */ f(gr, { disabled: i, ..._, children: /* @__PURE__ */ f(
            pr,
            {
              ref: g,
              "data-testid": e && `${e}-thumb`,
              className: j([
                S[`${x}__thumb`],
                {
                  [S[`${x}__thumb--dragging`]]: m
                }
              ])
            }
          ) })
        ] })
      }
    ),
    t && o === "right" && C()
  ] });
}, br = ge(_r);
br.displayName = "Toggle";
export {
  br as Toggle
};
//# sourceMappingURL=toggle.es.js.map
